import React from "react";
import CustomTabsGrid from "components/CustomTabs/CustomTabsGrid.js";
import TKBenxehang from "components/Thongke/Benxe/TKBenxehang.js";
import TKBenxekhach from "components/Thongke/Benxe/TKBenxekhach.js";
export default function Tkbenxe() {
  return (
    <div>
      <CustomTabsGrid
        headerColor="primary"
        tabs={[
          {
            tabName: "Báo cáo bến xe khách",
            tabContent: <TKBenxekhach />,
          },
          {
            tabName: "Báo cáo bến xe hàng",
            tabContent: <TKBenxehang />,
          },
        ]}
      />
    </div>
  );
}
